// @vue/component
import moment from 'moment';

export default {
  name: 'ReportsFormExportItemDaterange',

  props: {
    currentField: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      fieldValue: [this.currentField.default_value, this.currentField.dependent_field_details.default_value],
      minDate: null,
    };
  },
  computed: {
    pickerOptions() {
      let _this = this;
      return {
        disabledDate(date) {
          const pickedDate = moment(_this.minDate).valueOf();
          const threeMonthsBefore = moment(pickedDate).subtract(93, 'days').valueOf();
          const threeMonthsLater = moment(pickedDate).add(93, 'days').valueOf();
          const todayPlusOneDay = moment().add(0, 'days').valueOf();

          if (_this.minDate) {
            return (date.getTime() > threeMonthsLater) || (date.getTime() < threeMonthsBefore) || (date.getTime() > todayPlusOneDay);
          }
          return date.getTime() > todayPlusOneDay;
        },
        onPick({ maxDate, minDate }) {
          if (!minDate && _this.minDate) {
            _this.minDate = null;
          } else if (minDate) {
            _this.minDate = minDate.getTime();
          }
        },
        firstDayOfWeek: 1,
      };
    },
  },
};
